import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule, JsonPipe } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  AfterViewInit,
} from '@angular/core';
import { Route, Router } from '@angular/router';
import { BarPercentagemComponent } from '../../../../../core/shared/ui/bar-percentagem/bar-percentagem.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { LoaderService } from '../../../../../core/shared/services/loader.service';
import { ObjectivesService } from '../../../../../core/services/objectives.service';
import { TestsService } from '../../../../../core/services/tests.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../../../../core/services/auth.service';
import { AuthUser } from '../../../../../core/models/auth/auth.interface';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { STATES_OBJECTIVES } from '../../../../../core/shared/constants';
import { Objective } from '../../../../../core/models/objective.model';
import { DateRange, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { debounceTime, filter } from 'rxjs';
import { CustomDatePickerComponent } from '../../../../../core/shared/components/custom-date-picker/custom-date-picker.component';
import Swal from 'sweetalert2';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    BarPercentagemComponent,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    CustomDatePickerComponent,
    MatTooltipModule
  ],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ margin: 0, height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TableComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() data: Objective[] = [];
  @Input() itemsPerPage: number = 10;
  filteredData: Objective[] = [];
  @Output() itemDeleted = new EventEmitter<string>();
  @Output() designResponsive = new EventEmitter<boolean>();
  @Output() stateChanged = new EventEmitter<void>();
  @Output() reloadObjectives = new EventEmitter<void>();
  @Input() showFilters: boolean = true; // Controla la visibilidad de los filtros
  private authService: AuthService = inject(AuthService);
  authUser: AuthUser = this.authService.getAuthUser()!;
  private objectiveService: ObjectivesService = inject(ObjectivesService);

  // Propiedades para el modal de evidencia
  showEvidenceModal: boolean = false;
  currentObjective: any = null;
  currentActivity: any = null;
  evidenceFile: File | null = null;
  evidencePreview: string | null = null;
  evidenceFileName: string = '';
  isUploading: boolean = false;

  // Propiedades para el modal de confirmación de eliminación
  mostrarModalConfirmacionEliminacion: boolean = false;
  objetivoAEliminar: any | null = null;
  private testService: TestsService = inject(TestsService);
  private loader = inject(LoaderService);

  public STATES_OBJECTIVES = STATES_OBJECTIVES;

  //CREACION RAPIDA
  optionsDimensions: any[] = [];
  dimensionSelected: any | null = null;
  dateStart: string = '';
  dateEnd: string = '';
  nameObjective: string = '';

  expandedElement: any | null = null;
  creationInProgress: boolean = false;
  dataSource: any[] = [];
  columnsToDisplay = ['Nombre', 'Dimension', 'Inicio', 'Fin', 'Estado', 'Porcentaje', 'options'];
  menu1 = false;
  menu2 = false;
  selectedElement: any | null = null;
  selectedActivity: any | null = null;
  selectedButton: any | null = null;
  menuPosition = { top: '0px', left: '0px' };
  search: string = '';
  searchTerm: string = '';

  //RESPONSIVE
  isResponsive: boolean = false;

  selectedFilter: string = 'Todos';
  filterCount: number = 0;

  activityStateMenuOpenFor: any | null = null;
  objectiveOfActivityStateMenuOpen: any | null = null;
  objectiveStateMenuOpenFor: any | null = null;
  activityStatusOptions = {
    Nuevo: STATES_OBJECTIVES.EnProgreso.name,
    Empezado: STATES_OBJECTIVES.EnProgreso.name,
    Pendiente: STATES_OBJECTIVES.PorVencer.name,
    Terminado: STATES_OBJECTIVES.Terminado.name
  };

  // Nuevas propiedades para el diseño de la imagen
  selectedDimension: string = '';
  selectedStatus: string = '';
  filterFromDate: string = '';
  filterToDate: string = '';
  dimensionFilterOpen: boolean = false;
  statusFilterOpen: boolean = false;
  statusDropdownOpenFor: any | null = null;
  activityStateDropdownOpenFor: any | null = null;
  activityObjectiveDropdownOpenFor: any | null = null;
  dimensions: any[] = [];

  // Paginación
  currentPage: number = 1;
  totalItems: number = 0;
  totalPages: number = 0;
  paginatedData: Objective[] = [];

  // Ordenamiento
  sortField: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  // Filtros
  showModalFilters: boolean = false;

  //Calendario
  showModalCalendar: boolean = false;
  modalCalendarMode: string = '';
  modalCalendarValue: Date | null = null;
  placeholderCalendar: string = "dd/mm/aaaa";
  calendarMinDate: Date | null = null;

  readonly range = new FormGroup({
    from: new FormControl<Date | null>(null),
    to: new FormControl<Date | null>(null),
  });

  mobileView = window.innerWidth <= 768;
  tabletView = window.innerWidth > 768 && window.innerWidth <= 1024;

  constructor(private elRef: ElementRef, private router: Router) {
    // Detectar cambios en el tamaño de la pantalla
    window.addEventListener('resize', () => {
      this.checkResponsiveView();
    });
  }

  ngOnInit() {
    this.checkResponsiveView();
    this.filteredData = [...this.data];
    this.totalItems = this.data.length;
    this.filterCount = this.data.length;
    this.getDimensions();
    this.updatePagination();
    this.data.length > 6 ? this.dataSource = this.data.slice(0, 6) : this.dataSource = this.data;
  }

  ngAfterViewInit() {

    this.range.get("to")!.valueChanges.pipe(
      debounceTime(200)
    ).subscribe(event => {
      console.log('valueChanges-event', this.range.getRawValue());

      this.applyFilter(this.selectedFilter);
      this.applySearchAndFilter();

    });

  }


  // Helper para determinar si un color es oscuro
  isColorDark(hexColor: string): boolean {
    const color = hexColor.substring(1); // remove #
    const r = parseInt(color.substring(0, 2), 16); // Red
    const g = parseInt(color.substring(2, 4), 16); // Green
    const b = parseInt(color.substring(4, 6), 16); // Blue
    // Formula para luminosidad relativa
    const luminosity = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminosity < 128; // Umbral para considerar oscuro
  }

  getObjectiveStateColor(stateName: string): string {
    const stateKey = Object.keys(STATES_OBJECTIVES).find(key => STATES_OBJECTIVES[key as keyof typeof STATES_OBJECTIVES].name === stateName);
    if (stateKey) {
      return STATES_OBJECTIVES[stateKey as keyof typeof STATES_OBJECTIVES].color || '#FFFFFF'; // Default blanco
    }
    return '#FFFFFF'; // Default blanco
  }

  getObjectiveStateTextColor(stateName: string): string {
    const bgColor = this.getObjectiveStateColor(stateName);
    return this.isColorDark(bgColor) ? '#FFFFFF' : '#000000'; // Blanco para fondos oscuros, Negro para claros
  }

  getActivityStateColor(stateName: string): string {
    // Reutilizamos la misma lógica que para los objetivos si los estados son los mismos
    return this.getObjectiveStateColor(stateName);
  }

  getActivityStateTextColor(stateName: string): string {
    // Reutilizamos la misma lógica que para los objetivos
    return this.getObjectiveStateTextColor(stateName);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.filteredData = [...this.data];
      this.totalItems = this.data.length;
      this.filterCount = this.data.length;
      this.currentPage = 1;
      this.updatePagination();
      this.applyFilter(this.selectedFilter);
      this.applySearchAndFilter();
      this.applyFilters();
    }
  }

  cargarMasObjetivos() {
    this.dataSource = this.data;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkResponsive();
    this.updateMenuPosition();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    // Cerrar menú de opciones generales
    if (this.selectedElement && !this.selectedButton?.contains(event.target as Node)) {
      this.closeMenu();
    }

    // Verificar si el clic fue dentro de algún menú desplegable de estado
    const clickedElement = event.target as HTMLElement;
    const clickedInsideStateMenu = clickedElement.closest(
      '.activity-status, .activity-status-mobile, .activity-state-dropdown, .activity-state-dropdown-mobile, ' +
      '.objective-state-tag, .objective-state-dropdown, .objective-state-dropdown-mobile, .dropdown-icon'
    );

    // Solo cerrar los menús de estado si el clic fue fuera de ellos
    if (!clickedInsideStateMenu) {
      this.activityStateMenuOpenFor = null;
      this.objectiveOfActivityStateMenuOpen = null;
      this.objectiveStateMenuOpenFor = null;
      this.activityStateDropdownOpenFor = null;
      this.activityObjectiveDropdownOpenFor = null;
    }
  }

  private checkResponsive() {
    this.isResponsive = window.innerWidth <= 1200;
    this.designResponsive.emit(this.isResponsive);
    this.menu1 = false;
    this.menu2 = false;
  }

  checkResponsiveView() {
    const width = window.innerWidth;
    this.mobileView = width <= 768;
    this.tabletView = width > 768 && width <= 1024;
    this.isResponsive = this.mobileView || this.tabletView;
    this.designResponsive.emit(this.isResponsive);
  }

  openMenu(event: MouseEvent, element: any, menu: number, activity?: any) {
    event.stopPropagation();
    if (this.selectedElement === element) {
      this.selectedElement = null;
      this.selectedActivity = null;
      menu === 1 ? this.menu1 = false : this.menu2 = false;
    } else {
      menu === 1 ? this.menu1 = true : this.menu2 = true;
      this.selectedElement = element;
      activity ? this.selectedActivity = activity : this.selectedActivity = null;

      const button = event.target as HTMLElement;
      this.selectedButton = button;
      const rect = this.selectedButton.getBoundingClientRect();
      this.menuPosition = {
        top: `${rect.top + window.scrollY}px`,
        left: `${rect.left + window.scrollX - 185}px`
      };
    }
  }

  updateMenuPosition() {
    if (!this.selectedElement) return;

    const rect = this.selectedButton.getBoundingClientRect();
    this.menuPosition = {
      top: `${rect.top + window.scrollY}px`,
      left: `${rect.left - 185}px`
    };
  }

  closeMenu() {
    this.selectedElement = null;
    this.selectedActivity = null;
    this.menu1 = false;
    this.menu2 = false;
  }

  changeCreationInProgress() {
    this.nameObjective = '';
    this.dateStart = '';
    this.dateEnd = '';
    this.creationInProgress = !this.creationInProgress;
  }

  completeEstado(element: any, activity: any) {
    const objectiveUpdate = JSON.parse(JSON.stringify(element)); // Clonar para evitar mutación directa
    const index = objectiveUpdate.activities.findIndex((act: any) => act.name === activity.name);
    if (index === -1) return;

    objectiveUpdate.activities[index].state = STATES_OBJECTIVES.Terminado.name;
    objectiveUpdate.state = this.calcularEstadoObjetivo(objectiveUpdate);
    objectiveUpdate.percentage = this.calcularPorcentaje(objectiveUpdate);
    objectiveUpdate.activities[index].completed = true;

    this.updateObjective(objectiveUpdate)
      .then((response: any) => {
        if (response && response.data) {
          // Actualizar con los datos devueltos del servidor para asegurar consistencia
          const updatedObjective = response.data;
          const originalObjectiveIndex = this.data.findIndex(o => o._id === element._id);
          if (originalObjectiveIndex !== -1) {
            this.data[originalObjectiveIndex] = updatedObjective;
            this.applySearchAndFilter();

            // Emitir evento para notificar al componente padre que hubo un cambio de estado
            this.stateChanged.emit();

            // Recargar la lista de objetivos
            this.reloadObjectivesList();

            Swal.fire({
              title: 'Éxito',
              text: 'Actividad completada correctamente',
              icon: 'success',
              confirmButtonText: 'Ok',
              timer: 2000,
              timerProgressBar: true
            });
          }
        }
      })
      .catch(error => {
        console.error("Error completando estado de actividad:", error);
        Swal.fire({
          title: 'Error',
          text: 'No se pudo completar la actividad',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      });
  }

  calcularPorcentaje(objective: any): number {
    if (!objective.activities || objective.activities.length === 0) {
      return 0;
    }

    let totalActivities = objective.activities.length;
    let completedActivities = 0;
    let startedActivities = 0;

    objective.activities.forEach((activity: any) => {
      if (activity.state === STATES_OBJECTIVES.Terminado.name) {
        completedActivities++;
      } else if (activity.state === STATES_OBJECTIVES.EnProgreso.name) {
        startedActivities++;
      }
    });

    if (totalActivities === 0) return 0;

    // Cada actividad completada vale 100%, cada empezada 50%
    // El porcentaje total es el promedio ponderado.
    // Por ejemplo, si hay 2 actividades: 1 Terminada, 1 Empezada
    // (1 * 100 + 1 * 50) / 2 = 75%
    // Si hay 3 actividades: 1 Terminada, 1 Empezada, 1 Nueva
    // (1 * 100 + 1 * 50 + 0 * 0) / 3 = 50%

    const percentage = ((completedActivities * 100) + (startedActivities * 50)) / totalActivities;
    return Math.round(percentage);
  }

  calcularEstadoObjetivo(objective: any): string {
    // Usar el nuevo método que calcula por fecha
    return this.calculateObjectiveStateByDate(objective);
  }

  // Método para togglear la expansión de un objetivo para mostrar sus actividades
  toggleExpand(objetivo: Objective, event: Event) {
    event.stopPropagation();
    this.expandedElement = this.expandedElement === objetivo ? null : objetivo;
  }

  verObjetivo(objetivo: Objective) {
    this.router.navigate(['dashboard/new-objective'], {
      state: { objetivo: objetivo, editable: false }
    });
    this.closeMenu();
  }

  verActividades(objetivo: Objective) {
    this.router.navigate(['dashboard/new-objective'], {
      state: { objetivo: objetivo, editable: false, mostrarActividades: true }
    });
    this.closeMenu();
  }

  editarObjetivo(objetivo: Objective) {
    this.router.navigate(['dashboard/new-objective'], {
      state: { objetivo: objetivo, editable: true }
    });
    this.closeMenu();
  }

  eliminarObjetivo(id: string | undefined) {
    if (!id) return;

    // Buscar el objetivo por ID para mostrar su nombre en el modal
    const objetivo = this.data.find(obj => obj._id === id);
    if (objetivo) {
      this.objetivoAEliminar = objetivo;
      this.mostrarModalConfirmacionEliminacion = true;
    }
  }

  async getDimensions() {
    this.loader.show();
    this.testService.getDimensions().subscribe({
      next: (res: any) => {
        this.optionsDimensions = res.data;
        this.dimensions = res.data; // Actualizar también las dimensiones para el filtro
        this.loader.hide();
      },
      error: (error: any) => {
        console.error('Error al obtener dimensiones:', error);
        this.loader.hide();
      }
    });
  }

  changeDimensionSelected(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.dimensionSelected = selectElement.value;
  }

  agregarObjetivo() {

    this.router.navigate(["dashboard/new-objective"], {
      state: { objetivo: null, editable: true },
    });


    // if (this.dimensionSelected === null) {
    //   return;
    // }

    // const valueDimension = parseInt(this.dimensionSelected);
    // const objetivoGuardar = {
    //   userId: this.authUser.id,
    //   name: this.nameObjective,
    //   description: 'Sin descripción',
    //   dimension: this.optionsDimensions.find((option) => option.id == valueDimension),
    //   start: this.dateStart,
    //   end: this.dateEnd,
    //   state: STATES_OBJECTIVES.EnProgreso.name,
    //   activities: [],
    //   percentage: 0
    // };

    // this.loader.show();
    // this.objectiveService.createObjective(objetivoGuardar).subscribe({
    //   next: (res: any) => {
    //              // Recargar la lista de objetivos
    //      this.reloadObjectivesList();

    //      // Cerrar el formulario de creación
    //      this.changeCreationInProgress();
    //      this.loader.hide();
    //   },
    //   error: (error: any) => {
    //     console.error('Error al crear objetivo:', error);
    //     this.loader.hide();
    //   }
    // });
  }

  getFechaParaInput(fecha: string | null | undefined): string {
    if (!fecha) return '';
    if (fecha.includes('-')) return fecha;

    const [day, month, year] = fecha.split('/');
    return `${year}-${month}-${day}`;
  }

  // Métodos para el modal de confirmación de eliminación
  confirmarEliminacionObjetivo(): void {
    if (this.objetivoAEliminar && this.objetivoAEliminar._id) {
      // Emitir evento de eliminación
      this.itemDeleted.emit(this.objetivoAEliminar._id);

      // Recargar la lista de objetivos
      this.reloadObjectivesList();

      // Cerrar modal y limpiar
      this.cerrarModalConfirmacionEliminacion();

      // Mostrar mensaje de éxito usando SweetAlert
      Swal.fire({
        title: 'Éxito',
        text: 'Objetivo eliminado correctamente',
        icon: 'success',
        confirmButtonText: 'Ok'
      });
    }
  }

  cerrarModalConfirmacionEliminacion(): void {
    this.mostrarModalConfirmacionEliminacion = false;
    this.objetivoAEliminar = null;
  }

  changeFechaActividad(event: string, tipo: number): void {
    if (event) {
      const formattedDate = this.getFormattedFecha(event);
      if (tipo === 1) {
        this.dateStart = formattedDate;
      } else {
        this.dateEnd = formattedDate;
      }
    }
  }

  getFormattedFecha(fecha: string | null | undefined): string {
    if (!fecha || fecha === '') return '';
    if (fecha.includes('/')) return fecha;

    const [year, month, day] = fecha.split('-');
    return `${day}/${month}/${year}`;
  }

  filtrarObjetivos(filter: string) {
    switch (filter) {
      case 'todos':
        this.dataSource = this.data;
        break;
      case 'nuevos':
        this.dataSource = this.data.filter((element) => element.state === STATES_OBJECTIVES.EnProgreso.name);
        break;
      case 'empezados':
        this.dataSource = this.data.filter((element) => element.state === STATES_OBJECTIVES.EnProgreso.name);
        break;
      case 'terminados':
        this.dataSource = this.data.filter((element) => element.state === STATES_OBJECTIVES.Terminado.name);
        break;
      // Añadir caso para Pendiente si es necesario filtrar por él en el futuro
      default:
        break;
    }
  }

  filtrarObjetivoPorNombre(event: string) {
    if (event === null) return;
    if (event === '') {
      this.dataSource = this.data;
      return;
    } else {
      this.dataSource = this.data.filter((element) => {
        const nameMatch = element.name.toLowerCase().includes(event.toLowerCase());
        const dimensionMatch = element.dimension && element.dimension.name ?
          element.dimension.name.toLowerCase().includes(event.toLowerCase()) : false;
        return nameMatch || dimensionMatch;
      });
    }
  }

  async updateObjective(objective: any) {
    this.loader.show();
    try {
      // Cambiamos toPromise() por un patrón más explícito usando firstValueFrom
      return new Promise((resolve, reject) => {
        this.objectiveService.updateObjective(objective).subscribe({
          next: (response) => {
            this.loader.hide();
            resolve(response);
          },
          error: (error) => {
            console.error('Error al actualizar objetivo:', error);
            this.loader.hide();
            reject(error);
          }
        });
      });
    } catch (error) {
      console.error('Error al actualizar objetivo:', error);
      this.loader.hide();
      throw error;
    }
  }

  calcularTiempoFechaFinal(fechaStr: string): string {
    const [dia, mes, anio] = fechaStr.split('/').map(Number);
    const fecha = new Date(anio, mes - 1, dia);

    const ahora = new Date();
    ahora.setHours(0, 0, 0, 0);
    const diferenciaDias = (fecha.getTime() - ahora.getTime()) / (1000 * 60 * 60 * 24);

    if (diferenciaDias === 0) return "Hoy";
    if (diferenciaDias === -1) return "Ayer";
    if (diferenciaDias === 1) return "Mañana";

    return fechaStr;
  }

  applyFilter(filter: string) {
    this.selectedFilter = filter;
    this.applySearchAndFilter();
  }

  applySearchAndFilter() {
    let tempData = [...this.data];

    // Aplicar filtro de estado (Todos, Nuevo, Empezado, Terminado)
    if (this.selectedFilter !== 'Todos') {
      tempData = tempData.filter(objetivo => {
        if (this.selectedFilter === 'Nuevo') return objetivo.state === STATES_OBJECTIVES.EnProgreso.name;
        if (this.selectedFilter === 'Empezado') return objetivo.state === STATES_OBJECTIVES.EnProgreso.name;
        if (this.selectedFilter === 'Terminado') return objetivo.state === STATES_OBJECTIVES.Terminado.name;
        // Añadir caso para Pendiente si es necesario filtrar por él en el futuro
        // if (this.selectedFilter === 'Pendiente') return objetivo.state === STATES_OBJECTIVES.Pendiente.name;
        return true;
      });
    }

    // Aplicar filtro de búsqueda por término
    if (this.searchTerm && this.searchTerm.trim() !== '') {
      const lowerSearchTerm = this.searchTerm.toLowerCase().trim();
      tempData = tempData.filter(objetivo => {
        const nombreObjetivoMatch = objetivo.name.toLowerCase().includes(lowerSearchTerm);
        const actividadMatch = objetivo.activities.some(activity =>
          activity.name.toLowerCase().includes(lowerSearchTerm)
        );
        return nombreObjetivoMatch || actividadMatch;
      });
    }

    this.filteredData = tempData;
    this.filterCount = this.filteredData.length; // Actualizar contador para la pestaña "Todos"
    // Para la paginación o "cargar más", si es necesario actualizar el dataSource
    if (this.data.length > 6 && this.selectedFilter === 'Todos' && (!this.searchTerm || this.searchTerm.trim() === '')) {
      this.filteredData = this.filteredData.slice(0, 6);
    }

    var filterDate = this.range.getRawValue();
    if (filterDate.from && filterDate.from != null) {
      this.filteredData = this.filteredData.filter(x => x.start >= filterDate.from!.toISOString());
      if (filterDate.to && filterDate.to != null) {
        this.filteredData = this.filteredData.filter(x => x.start <= filterDate.to!.toISOString());
      }
    }
    this.dataSource = this.filteredData;
  }

  handleMenuAction(action: number, objetivo: Objective) {
    switch (action) {
      case 1: // Ver Objetivo
        this.verObjetivo(objetivo);
        break;
      case 2: // Ver actividades
        this.verActividades(objetivo);
        break;
      case 3: // Editar
        this.editarObjetivo(objetivo);
        break;
      case 4: // Eliminar
        this.eliminarObjetivo(objetivo._id);
        break;
    }
  }

  toggleActivityStateMenu(objetivo: Objective, activity: any, event: MouseEvent) {
    event.stopPropagation(); // Prevenir que el click se propague a onClickOutside inmediatamente
    if (this.activityStateMenuOpenFor === activity && this.objectiveOfActivityStateMenuOpen === objetivo) {
      this.activityStateMenuOpenFor = null;
      this.objectiveOfActivityStateMenuOpen = null;
    } else {
      this.activityStateMenuOpenFor = activity;
      this.objectiveOfActivityStateMenuOpen = objetivo;
      // Asegurarse de que otros menús estén cerrados
      this.closeMenu();
    }
  }

  changeActivityState(objetivo: Objective, activity: any, newState: string) {
    const objectiveToUpdate = JSON.parse(JSON.stringify(objetivo)); // Clonar para evitar mutación directa
    const activityIndex = objectiveToUpdate.activities.findIndex((act: any) => act.name === activity.name && act.start === activity.start);

    if (activityIndex !== -1) {
      // Validar que el nuevo estado sea válido para actividades
      const validActivityStates = ['Nuevo', 'Empezado', 'Pendiente', 'Terminado', 'Completado'];
      if (validActivityStates.includes(newState)) {
        objectiveToUpdate.activities[activityIndex].state = newState;
        objectiveToUpdate.activities[activityIndex].completed = false;
        if (newState === "Terminado" || newState === "Completado") {
          objectiveToUpdate.activities[activityIndex].completed = true;
        }
      } else {
        console.warn(`Nuevo estado '${newState}' no reconocido para la actividad.`);
        this.activityStateMenuOpenFor = null;
        this.objectiveOfActivityStateMenuOpen = null;
        return;
      }
      console.log('objectiveToUpdate', objectiveToUpdate);
      // Calcular el nuevo estado del objetivo basado en las actividades
      objectiveToUpdate.state = this.calcularEstadoObjetivo(objectiveToUpdate);
      objectiveToUpdate.percentage = this.calcularPorcentaje(objectiveToUpdate);

      // Asegurarnos de que se complete la actualización antes de actualizar la UI
      this.updateObjective(objectiveToUpdate)
        .then((response: any) => {
          if (response && response.data) {
            // Actualizar con los datos devueltos del servidor para asegurar consistencia
            const updatedObjective = response.data;
            const originalObjectiveIndex = this.data.findIndex(o => o._id === objetivo._id);
            if (originalObjectiveIndex !== -1) {
              this.data[originalObjectiveIndex] = updatedObjective;
              this.applySearchAndFilter();

              // Emitir evento para notificar al componente padre que hubo un cambio de estado
              this.stateChanged.emit();

              // Recargar la lista de objetivos
              this.reloadObjectivesList();

              Swal.fire({
                title: 'Éxito',
                text: `Estado cambiado a "${newState}" correctamente`,
                icon: 'success',
                confirmButtonText: 'Ok',
                timer: 2000,
                timerProgressBar: true
              });
            }
          }
        })
        .catch(error => {
          console.error("Error actualizando estado de actividad:", error);
          Swal.fire({
            title: 'Error',
            text: 'No se pudo actualizar el estado de la actividad',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        })
        .finally(() => {
          this.activityStateMenuOpenFor = null;
          this.objectiveOfActivityStateMenuOpen = null;
        });
    } else {
      this.activityStateMenuOpenFor = null;
      this.objectiveOfActivityStateMenuOpen = null;
    }
  }

  // Nuevos métodos para manejar las opciones del menú de actividades
  verActividad(objetivo: Objective, activity: any) {
    // Al igual que verObjetivo, pero enfocado en la actividad específica
    this.router.navigate(['dashboard/new-objective'], {
      state: { objetivo: objetivo, editable: false, actividadSeleccionada: activity }
    });
    this.closeMenu();
  }

  editarActividad(objetivo: Objective, activity: any) {
    // Al igual que editarObjetivo, pero enfocado en la actividad específica
    this.router.navigate(['dashboard/new-objective'], {
      state: { objetivo: objetivo, editable: true, actividadSeleccionada: activity }
    });
    this.closeMenu();
  }

  eliminarActividad(objetivo: Objective, activity: any) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: '¿Deseas eliminar esta actividad?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6'
    }).then((result) => {
      if (result.isConfirmed) {
        const objectiveToUpdate = JSON.parse(JSON.stringify(objetivo)); // Clonar para evitar mutación directa
        const activityIndex = objectiveToUpdate.activities.findIndex((act: any) =>
          act.name === activity.name && act.start === activity.start
        );

        if (activityIndex !== -1) {
          objectiveToUpdate.activities.splice(activityIndex, 1);
          objectiveToUpdate.state = this.calcularEstadoObjetivo(objectiveToUpdate);
          objectiveToUpdate.percentage = this.calcularPorcentaje(objectiveToUpdate);

          this.updateObjective(objectiveToUpdate)
            .then((response: any) => {
              if (response && response.data) {
                // Actualizar con los datos devueltos del servidor para asegurar consistencia
                const updatedObjective = response.data;
                const originalObjectiveIndex = this.data.findIndex(o => o._id === objetivo._id);
                if (originalObjectiveIndex !== -1) {
                  this.data[originalObjectiveIndex] = updatedObjective;
                  this.applySearchAndFilter();

                  // Emitir evento para notificar al componente padre que hubo un cambio de estado
                  this.stateChanged.emit();

                  // Recargar la lista de objetivos
                  this.reloadObjectivesList();

                  Swal.fire({
                    title: 'Éxito',
                    text: 'Actividad eliminada correctamente',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                  });
                }
              }
            })
            .catch(error => {
              console.error("Error eliminando actividad:", error);
              Swal.fire({
                title: 'Error',
                text: 'No se pudo eliminar la actividad',
                icon: 'error',
                confirmButtonText: 'Ok'
              });
            });
        }
      }
    });
    this.closeMenu();
  }

  // Método para depurar el estado del objectiveStateMenuOpenFor
  isMenuOpen(objetivo: Objective): boolean {
    return this.objectiveStateMenuOpenFor === objetivo;
  }

  // Método para abrir/cerrar el menú de estado de objetivo
  toggleObjectiveStateMenu(objetivo: Objective, event: MouseEvent) {
    event.preventDefault(); // Prevenir comportamiento por defecto
    event.stopPropagation(); // Prevenir que el click se propague

    // Cerrar cualquier otro menú abierto
    this.closeMenu();
    this.activityStateMenuOpenFor = null;
    this.objectiveOfActivityStateMenuOpen = null;

    // Alternar el menú de estado de este objetivo
    this.objectiveStateMenuOpenFor = (this.objectiveStateMenuOpenFor === objetivo) ? null : objetivo;
  }

  // Método para cambiar el estado de un objetivo
  changeObjectiveState(objetivo: Objective, newState: string) {
    const objectiveToUpdate = JSON.parse(JSON.stringify(objetivo)); // Clonar para evitar mutación directa

    // Verificar que el nuevo estado sea válido
    if (Object.values(STATES_OBJECTIVES).find(s => s.name === newState)) {
      objectiveToUpdate.state = newState;

      // Actualizar el porcentaje si es necesario
      if (newState === STATES_OBJECTIVES.Terminado.name) {
        objectiveToUpdate.percentage = 100; // Si está terminado, el porcentaje es 100%
      } else if (newState === STATES_OBJECTIVES.EnProgreso.name && objectiveToUpdate.percentage === 0) {
        objectiveToUpdate.percentage = 25; // Si está empezado y el porcentaje era 0, ponerlo en 25%
      } else if (newState === STATES_OBJECTIVES.PorVencer.name || newState === STATES_OBJECTIVES.Atrasado.name) {
        // Si se cambia a Por vencer o Atrasado, verificar el porcentaje basado en actividades
        objectiveToUpdate.percentage = this.calcularPorcentaje(objectiveToUpdate);
      }
    } else {
      console.warn(`Nuevo estado '${newState}' no reconocido para el objetivo.`);
      this.objectiveStateMenuOpenFor = null;
      return;
    }

    // Actualizar el objetivo en el servidor
    this.updateObjective(objectiveToUpdate)
      .then((response: any) => {
        if (response && response.data) {
          // Actualizar con los datos devueltos del servidor
          const updatedObjective = response.data;
          const originalObjectiveIndex = this.data.findIndex(o => o._id === objetivo._id);
          if (originalObjectiveIndex !== -1) {
            this.data[originalObjectiveIndex] = updatedObjective;
            this.applySearchAndFilter();

            // Emitir evento para notificar al componente padre que hubo un cambio de estado
            this.stateChanged.emit();

            // Recargar la lista de objetivos
            this.reloadObjectivesList();

            Swal.fire({
              title: 'Éxito',
              text: `Estado del objetivo cambiado a "${newState}" correctamente`,
              icon: 'success',
              confirmButtonText: 'Ok',
              timer: 2000,
              timerProgressBar: true
            });
          }
        }
      })
      .catch(error => {
        console.error("Error actualizando estado del objetivo:", error);
        Swal.fire({
          title: 'Error',
          text: 'No se pudo actualizar el estado del objetivo',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      })
      .finally(() => {
        this.objectiveStateMenuOpenFor = null;
      });
  }

  // Filtros
  filterMobile(): boolean {
    return window.innerWidth <= 768;
  }

  openModalFilters() {
    this.showModalFilters = true;
  }

  closeModalFilters() {
    this.showModalFilters = false;
  }

  confirmModalFilters() {
    this.showModalFilters = false;
  }

  openModalCalendar(mode: string, minDate: string | null = null) {
    // validate mode's value
    const allowedModes = ['start', 'end'];
    if (!allowedModes.includes(mode)) return;

    this.modalCalendarMode = mode;
    // in case we recieved a minDate, we assign it
    if (minDate != null) this.calendarMinDate = this.parseDDMMYYYY(minDate);
    this.showModalCalendar = true;
  }

  closeModalCalendar() {
    this.showModalCalendar = false;
    this.modalCalendarValue = null;
    this.modalCalendarMode = '';
    this.calendarMinDate = null;
  }

  confirmModalCalendar() {
    if (!this.modalCalendarValue) return;

    const formattedDate: string = this.formatDate(this.modalCalendarValue);

    switch (this.modalCalendarMode) {
      case "start":
        this.filterFromDate = formattedDate;
        this.filterToDate = '';
        break;
      case "end":
        this.filterToDate = formattedDate;
        break;
      default:
        return;
    }
    this.applyFilters();
    this.closeModalCalendar();
  }

  private formatDate(date: Date | null): string {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  onSelectedChange(date: Date) {
    this.modalCalendarValue = date;
  }

  toggleDimensionFilter() {
    this.dimensionFilterOpen = !this.dimensionFilterOpen;
    this.statusFilterOpen = false;
  }

  toggleStatusFilter() {
    this.statusFilterOpen = !this.statusFilterOpen;
    this.dimensionFilterOpen = false;
  }

  selectDimension(dimension: string) {
    this.selectedDimension = dimension;
    this.dimensionFilterOpen = false;
    this.applyFilters();
  }

  selectStatus(status: string) {
    this.selectedStatus = status;
    this.statusFilterOpen = false;
    this.applyFilters();
  }

  applyFilters() {
    let filtered = [...this.data];

    // Filtrar por dimensión
    if (this.selectedDimension) {
      filtered = filtered.filter(obj => obj.dimension.name === this.selectedDimension);
    }

    // Filtrar por estado
    if (this.selectedStatus) {
      filtered = filtered.filter(obj => {
        const status = this.calculateObjectiveStateByDate(obj);
        return status === this.selectedStatus;
      });
    }

    // Filtrar por fechas
    const from = this.parseDDMMYYYY(this.filterFromDate);
    const to = this.parseDDMMYYYY(this.filterToDate);

    if (from && to) {
      if (this.filterFromDate) {
        filtered = filtered.filter(obj => {
          const d = this.parseDDMMYYYY(obj.start);
          return d !== null && d >= from;
        });
      }
      if (this.filterToDate) {
        filtered = filtered.filter(obj => {
          const d = this.parseDDMMYYYY(obj.end);
          return d !== null && d <= to;
        });
      }
    }

    this.filteredData = filtered;
    this.totalItems = filtered.length;
    this.currentPage = 1;
    this.updatePagination();
  }

  parseDDMMYYYY(dateStr: string): Date | null {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day);
  }

  formatDateToDisplay(dateStr: string): string {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-').map(Number);
    return `${day}/${month}/${year}`;
  }

  closeAllDropdowns() {
    this.dimensionFilterOpen = false;
    this.statusFilterOpen = false;
    this.activityStateDropdownOpenFor = null;
    this.activityObjectiveDropdownOpenFor = null;
  }

  // Ordenamiento
  sortBy(field: string) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }

    this.filteredData.sort((a, b) => {
      let aValue: any;
      let bValue: any;

      switch (field) {
        case 'name':
          aValue = a.name;
          bValue = b.name;
          break;
        case 'dimension':
          aValue = a.dimension.name;
          bValue = b.dimension.name;
          break;
        case 'startDate':
          aValue = new Date(a.start);
          bValue = new Date(b.start);
          break;
        case 'endDate':
          aValue = new Date(a.end);
          bValue = new Date(b.end);
          break;
        case 'updateDate':
          aValue = new Date(a.updatedAt || '2025-07-13');
          bValue = new Date(b.updatedAt || '2025-07-13');
          break;
        case 'updatedBy':
          aValue = 'Usuario';
          bValue = 'Usuario';
          break;
        case 'status':
          aValue = this.getStatusText(a.state);
          bValue = this.getStatusText(b.state);
          break;
        default:
          return 0;
      }

      if (aValue < bValue) return this.sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    this.updatePagination();
  }

  // Paginación
  updatePagination() {
    this.totalPages = Math.ceil(this.filteredData.length / this.itemsPerPage);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedData = this.filteredData.slice(startIndex, endIndex);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.updatePagination();
  }

  onItemsPerPageChange() {
    this.currentPage = 1;
    this.updatePagination();
  }

  // Método para obtener las páginas visibles alrededor de la página actual
  getVisiblePages(): number[] {
    const visiblePages: number[] = [];
    const maxVisiblePages = 5; // Máximo número de páginas a mostrar

    if (this.totalPages <= maxVisiblePages) {
      // Si hay pocas páginas, mostrar todas
      for (let i = 2; i < this.totalPages; i++) {
        visiblePages.push(i);
      }
    } else {
      // Lógica para mostrar páginas alrededor de la actual
      const start = Math.max(2, this.currentPage - 1);
      const end = Math.min(this.totalPages - 1, this.currentPage + 1);

      // Asegurar que siempre mostremos al menos 2-3 páginas en el medio
      let actualStart = start;
      let actualEnd = end;

      if (this.currentPage <= 3) {
        // Si estamos cerca del inicio, mostrar más páginas al final
        actualEnd = Math.min(this.totalPages - 1, 4);
      } else if (this.currentPage >= this.totalPages - 2) {
        // Si estamos cerca del final, mostrar más páginas al inicio
        actualStart = Math.max(2, this.totalPages - 3);
      }

      for (let i = actualStart; i <= actualEnd; i++) {
        visiblePages.push(i);
      }
    }

    return visiblePages;
  }

  // Método para obtener el texto de elementos mostrados
  getDisplayedItemsText(): string {
    if (this.totalItems === 0) {
      return '0';
    }

    const startItem = (this.currentPage - 1) * this.itemsPerPage + 1;
    const endItem = Math.min(this.currentPage * this.itemsPerPage, this.totalItems);

    if (startItem === endItem) {
      return `${startItem}`;
    }

    return `${startItem}-${endItem}`;
  }

  // Utilidades
  getInitials(name: string): string {
    return name.split(' ').map(word => word.charAt(0)).join('').toUpperCase().slice(0, 2);
  }

  getStatusText(state: string): string {
    switch (state) {
      case STATES_OBJECTIVES.Terminado.name:
        return 'Terminado';
      case STATES_OBJECTIVES.PorVencer.name:
        return 'Por Vencer';
      case STATES_OBJECTIVES.Atrasado.name:
        return 'Atrasado';
      case STATES_OBJECTIVES.Eliminado.name:
        return 'Eliminado';
      case STATES_OBJECTIVES.EnProgreso.name:
        return 'En progreso';
      default:
        return state;
    }
  }

  getStatusClass(state: string): string {
    switch (state) {
      case STATES_OBJECTIVES.Terminado.name:
        return 'terminado';
      case STATES_OBJECTIVES.PorVencer.name:
        return 'por-vencer';
      case STATES_OBJECTIVES.Atrasado.name:
        return 'atrasado';
      case STATES_OBJECTIVES.Eliminado.name:
        return 'eliminado';
      case STATES_OBJECTIVES.EnProgreso.name:
        return 'en-progreso';
      default:
        return '';
    }
  }

  // Método para calcular el estado basado en la fecha de fin del objetivo
  calculateObjectiveStateByDate(objetivo: Objective): string {
    // Si el objetivo ya está marcado como eliminado, mantener ese estado
    if (objetivo.state === STATES_OBJECTIVES.Eliminado.name) {
      return STATES_OBJECTIVES.Eliminado.name;
    }

    // Si el objetivo está completado (100% o todas las actividades terminadas), es Terminado
    if (objetivo.percentage === 100 || this.areAllActivitiesCompleted(objetivo)) {
      return STATES_OBJECTIVES.Terminado.name;
    }

    // Obtener fecha actual
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Convertir fecha de fin del objetivo
    const endDateStr = objetivo.end;
    let endDate: Date;

    if (endDateStr.includes('/')) {
      // Formato DD/MM/YYYY
      const [day, month, year] = endDateStr.split('/').map(Number);
      endDate = new Date(year, month - 1, day);
    } else {
      // Formato ISO o YYYY-MM-DD
      endDate = new Date(endDateStr);
    }

    endDate.setHours(0, 0, 0, 0);

    // Calcular diferencia en días
    const diffTime = endDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Si tiene actividades en progreso, está En progreso
    if (this.hasActivitiesInProgress(objetivo)) {
      // Si ya pasó la fecha de fin, está Atrasado
      if (diffDays < 0) {
        return STATES_OBJECTIVES.Atrasado.name;
      }
      // Si está dentro del plazo, está En progreso
      return STATES_OBJECTIVES.EnProgreso.name;
    }

    // Si no tiene actividades en progreso
    if (diffDays < 0) {
      // Ya pasó la fecha, está Atrasado
      return STATES_OBJECTIVES.Atrasado.name;
    } else if (diffDays <= 7) {
      // Falta una semana o menos, está Por vencer
      return STATES_OBJECTIVES.PorVencer.name;
    } else {
      // Aún tiene tiempo, está En progreso (pendiente de empezar)
      return STATES_OBJECTIVES.EnProgreso.name;
    }
  }

  // Verificar si todas las actividades están completadas
  private areAllActivitiesCompleted(objetivo: Objective): boolean {
    if (!objetivo.activities || objetivo.activities.length === 0) {
      return false;
    }
    return objetivo.activities.every((activity: any) =>
      activity.state === 'Terminado' || activity.state === 'Completado' || activity.completed === true
    );
  }

  // Verificar si hay actividades en progreso
  private hasActivitiesInProgress(objetivo: Objective): boolean {
    if (!objetivo.activities || objetivo.activities.length === 0) {
      return false;
    }
    return objetivo.activities.some((activity: any) =>
      activity.state === 'Empezado' || activity.state === 'En progreso' ||
      (activity.state !== 'Terminado' && activity.state !== 'Completado' && activity.completed !== true)
    );
  }

  toggleStatusDropdown(objetivo: Objective, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    this.statusDropdownOpenFor = this.statusDropdownOpenFor === objetivo ? null : objetivo;
  }

  toggleActivityStatusDropdown(objetivo: Objective, activity: any, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (this.activityStateDropdownOpenFor === activity && this.activityObjectiveDropdownOpenFor === objetivo) {
      this.activityStateDropdownOpenFor = null;
      this.activityObjectiveDropdownOpenFor = null;
    } else {
      this.activityStateDropdownOpenFor = activity;
      this.activityObjectiveDropdownOpenFor = objetivo;

      // Pequeño delay para asegurar que el DOM se actualice antes de ajustar la posición
      setTimeout(() => {
        this.adjustDropdownPosition(event.target as HTMLElement);
      }, 10);
    }
  }

  // Escuchar clics fuera del dropdown para cerrarlo
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Si el clic no está dentro del dropdown o del botón que lo activa, cerrar el dropdown
    if (!target.closest('.activity-status-dropdown') && !target.closest('.activity-status-dropdown-menu')) {
      this.activityStateDropdownOpenFor = null;
      this.activityObjectiveDropdownOpenFor = null;
    }
  }

  // Método para ajustar la posición del dropdown
  adjustDropdownPosition(triggerElement: HTMLElement) {
    try {
      const dropdown = document.querySelector('.activity-status-dropdown-menu') as HTMLElement;
      if (!dropdown) return;

      const triggerRect = triggerElement.getBoundingClientRect();
      const dropdownRect = dropdown.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Si el dropdown se va a salir del viewport hacia abajo
      if (triggerRect.bottom + dropdownRect.height + 10 > viewportHeight) {
        // Mostrar hacia arriba
        dropdown.style.top = 'auto';
        dropdown.style.bottom = '100%';
        dropdown.style.marginTop = '0';
        dropdown.style.marginBottom = '4px';
      } else {
        // Mostrar hacia abajo (posición por defecto)
        dropdown.style.top = '100%';
        dropdown.style.bottom = 'auto';
        dropdown.style.marginTop = '4px';
        dropdown.style.marginBottom = '0';
      }
    } catch (error) {
      console.warn('Error ajustando posición del dropdown:', error);
    }
  }

  // Método para recargar objetivos
  reloadObjectivesList() {
    this.reloadObjectives.emit();
  }

  // Métodos para manejo de actividades
  completeActivity(objetivo: Objective, activity: any) {
    // Validar si la actividad tiene evidencia
    if (!activity.evidence || activity.evidence.trim() === '') {
      // No tiene evidencia, abrir modal para adjuntar
      this.openEvidenceModal(objetivo, activity);
    } else {
      // Ya tiene evidencia, completar directamente
      this.completeEstado(objetivo, activity);
    }
  }

  // Abrir modal para adjuntar evidencia
  openEvidenceModal(objetivo: any, activity: any) {
    this.currentObjective = objetivo;
    this.currentActivity = activity;
    this.showEvidenceModal = true;
    this.evidenceFile = null;
    this.evidencePreview = null;
    this.evidenceFileName = '';
  }

  // Cerrar modal de evidencia
  closeEvidenceModal() {
    this.showEvidenceModal = false;
    this.currentObjective = null;
    this.currentActivity = null;
    this.evidenceFile = null;
    this.evidencePreview = null;
    this.evidenceFileName = '';
    this.isUploading = false;
  }

  // Manejar selección de archivo de evidencia
  onEvidenceFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    // Validar tipo de archivo
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf'];
    if (!validTypes.includes(file.type)) {
      Swal.fire({
        title: 'Error',
        text: 'Solo se permiten archivos de imagen (JPG, PNG, GIF) o PDF',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
      return;
    }

    // Validar tamaño (10MB para PDF, 5MB para imágenes)
    const maxSize = file.type === 'application/pdf' ? 10 * 1024 * 1024 : 5 * 1024 * 1024;
    if (file.size > maxSize) {
      const sizeLimit = file.type === 'application/pdf' ? '10MB' : '5MB';
      Swal.fire({
        title: 'Error',
        text: `El archivo es demasiado grande. Tamaño máximo: ${sizeLimit}`,
        icon: 'error',
        confirmButtonText: 'Ok'
      });
      return;
    }

    this.evidenceFile = file;
    this.evidenceFileName = file.name;

    // Crear preview
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.evidencePreview = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    } else if (file.type === 'application/pdf') {
      this.evidencePreview = 'pdf';
    }
  }

  // Método para obtener el tipo de archivo
  getFileType(evidence: string): string {
    if (!evidence) return 'none';
    if (evidence === 'pdf' || evidence.toLowerCase().includes('pdf')) return 'pdf';
    return 'image';
  }

  // Confirmar y guardar evidencia
  async confirmEvidenceAndComplete() {
    if (!this.evidenceFile || !this.currentActivity || !this.currentObjective) return;

    this.isUploading = true;

    try {
      // Convertir archivo a base64
      const base64 = await this.fileToBase64(this.evidenceFile);

      // Actualizar la actividad con la evidencia
      const objectiveUpdate = JSON.parse(JSON.stringify(this.currentObjective));
      const activityIndex = objectiveUpdate.activities.findIndex((act: any) => act.name === this.currentActivity.name);

      if (activityIndex !== -1) {
        objectiveUpdate.activities[activityIndex].evidence = base64;
        objectiveUpdate.activities[activityIndex].state = STATES_OBJECTIVES.Terminado.name;
        objectiveUpdate.state = this.calcularEstadoObjetivo(objectiveUpdate);
        objectiveUpdate.percentage = this.calcularPorcentaje(objectiveUpdate);
        objectiveUpdate.activities[activityIndex].completed = true;

        // Guardar en el servidor
        const response: any = await this.updateObjective(objectiveUpdate);

        if (response && response.data) {
          // Actualizar datos locales
          const originalObjectiveIndex = this.data.findIndex(o => o._id === this.currentObjective._id);
          if (originalObjectiveIndex !== -1) {
            this.data[originalObjectiveIndex] = response.data;
            this.applySearchAndFilter();
            this.stateChanged.emit();
            this.reloadObjectivesList();
          }

          this.closeEvidenceModal();

          Swal.fire({
            title: 'Éxito',
            text: 'Actividad completada con evidencia adjunta',
            icon: 'success',
            confirmButtonText: 'Ok',
            timer: 2000,
            timerProgressBar: true
          });
        }
      }
    } catch (error) {
      console.error('Error al guardar evidencia:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo guardar la evidencia. Inténtalo de nuevo.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
    } finally {
      this.isUploading = false;
    }
  }

  // Convertir archivo a base64
  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        resolve(result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  // Descargar archivo de evidencia
  downloadEvidenceFile() {
    if (!this.evidenceFile) return;

    try {
      // Crear URL para descarga
      const url = URL.createObjectURL(this.evidenceFile);

      // Crear elemento anchor para descarga
      const link = document.createElement('a');
      link.href = url;
      link.download = this.evidenceFileName;
      link.style.display = 'none';

      // Agregar al DOM, hacer clic y remover
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Limpiar URL
      URL.revokeObjectURL(url);

      // Mostrar mensaje de éxito
      Swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        html: 'Archivo descargado exitosamente',
        icon: 'success',
        customClass: {
          container: 'alert-container'
        }
      });
    } catch (error) {
      console.error('Error al descargar archivo:', error);
      Swal.fire({
        title: 'Error',
        html: 'Error al descargar el archivo',
        icon: 'error',
        customClass: {
          container: 'alert-container',
          confirmButton: 'alert-confirmButton'
        }
      });
    }
  }



  getActivityStatusText(state: string): string {
    switch (state) {
      case 'Terminado':
      case 'Completado':
        return 'Completado';
      case 'Empezado':
        return 'En progreso';
      case 'Pendiente':
        return 'Pendiente';
      case 'Nuevo':
        return 'Nuevo';
      default:
        return state;
    }
  }

  getActivityStatusClass(state: string): string {
    switch (state) {
      case 'Terminado':
      case 'Completado':
        return 'completed';
      case 'Empezado':
        return 'in-progress';
      case 'Pendiente':
        return 'pending';
      case 'Nuevo':
        return 'new';
      default:
        return '';
    }
  }

  // Método para truncar texto y agregar salto de línea cada 15 caracteres
  truncateWithLineBreak(text: string, maxLength: number = 15, totalLength: number = 30): string {
    if (!text) return '';

    if (text.length <= maxLength) {
      return text;
    }

    if (text.length > totalLength) {
      text = text.substring(0, totalLength) + '...';
    }

    // Dividir el texto en partes de maxLength caracteres
    const parts: string[] = [];
    for (let i = 0; i < text.length; i += maxLength) {
      parts.push(text.substring(i, i + maxLength));
    }

    // Unir las partes con saltos de línea
    return parts.join('\n');
  }

  truncate(text: string, totalLength: number = 30): string {

    if (text.length > totalLength) {
      text = text.substring(0, totalLength) + '...';
    }
    console.log("truncate: ", text);
    return text;
  }

}